module.exports = __webpack_public_path__ + "static/media/skeleton.222ca451.svg";